module.exports = __webpack_public_path__ + "img/logo_header_color.fccae921.png";